namespace Matrix.Workflow {
    export interface ClientFunctionTriggerParameterForm {
        Name: Serenity.StringEditor;
        Title: Serenity.StringEditor;
        Type: Serenity.EnumEditor;
        Visible: Serenity.BooleanEditor;
        Required: Serenity.BooleanEditor;
        Size: Serenity.IntegerEditor;
        Scale: Serenity.IntegerEditor;
        DefaultValue: Serenity.StringEditor;
        EditorType: Serenity.LookupEditor;
    }

    export class ClientFunctionTriggerParameterForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.ClientFunctionTriggerParameter';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ClientFunctionTriggerParameterForm.init)  {
                ClientFunctionTriggerParameterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;

                Q.initFormType(ClientFunctionTriggerParameterForm, [
                    'Name', w0,
                    'Title', w0,
                    'Type', w1,
                    'Visible', w2,
                    'Required', w2,
                    'Size', w3,
                    'Scale', w3,
                    'DefaultValue', w0,
                    'EditorType', w4
                ]);
            }
        }
    }
}
